<ngx-loading [show]="loading"></ngx-loading>
<ngx-loading [show]="disableGrid" id="gridDisableDiv"></ngx-loading>

<router-outlet></router-outlet>

<p-overlayPanel #hoverPanel id="hoverPanel" [dismissable]="false">
  Content
</p-overlayPanel>
<app-actionpanel></app-actionpanel>
